/* eslint-disable no-unused-vars */
import fslightbox from 'fslightbox';
import lozad from 'lozad';
import MicroModal from 'micromodal';

import SliderTypeGrid from '@/modules/SliderTypeGrid/SliderTypeGrid.js';
import Anchor from '@/modules/Anchor/Anchor.js';

import initHeaderComponent from '@components/header/scripts.js';
import initFilter from '@components/filter/scripts.js';
import { initCloudTagsTypeText, initCloudTagsWithIcons } from '@components/tags/scripts.js';
import initSearch from '@components/search/scripts.js';
import initSearchPersons from '@components/search-persons/scripts.js';
import { initPartnersList, initPartnersBroadcast, initPartnersMix } from '@components/partners/scripts.js';
import initCardEvent from '@components/card-event/scripts.js';
import initCardEventNew from '@components/card-event-new/scripts.js';
import initCardNews from '@components/card-news/scripts.js';

import initPlacesList from '@components/section-places/scripts.js';
import initCitiesList from '@components/section-cities/scripts.js';

import initSliderRandomized from '@components/slider-randomized/init.js';

import broadcastCircle from '@components/broadcast-circle/scripts.js';
import broadcastSlider from '@components/section-broadcast/scripts.js';

import mountDateSelect from '@components/date-select/scripts.js';
import initSelect from '@components/select/scripts.js';
import eventsOptions from '@components/events-option/scripts.js';
import mountProgramPage from '@components/program-page/index.js';

const initLozadModule = () => {
  const observer = lozad();
  observer.observe();
};

const initSliderTypeGrid = () => {
  const elements = document.querySelectorAll('[data-component="slider-grid"]');

  elements.forEach((element) => {
    new SliderTypeGrid(element);
  });
};

const initAnchorLink = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="anchor"]'));

  elements.forEach((element) => {
    new Anchor(element);
  });
};

const initModal = () => {
  MicroModal.init({
    disableScroll: true,
  });
};

const init = () => {
  initHeaderComponent();

  initSliderTypeGrid();
  initFilter();
  initSearch();
  initSearchPersons();
  initCardEvent();

  initPartnersList();
  initPartnersBroadcast();
  initPartnersMix();

  initCloudTagsTypeText();
  initCloudTagsWithIcons();

  initPlacesList();
  initCitiesList();

  initSliderRandomized();

  initLozadModule();

  initAnchorLink();

  initModal();

  broadcastCircle();
  broadcastSlider();

  mountDateSelect();
  initSelect();
  mountProgramPage();
  eventsOptions();
  initCardEventNew();

  initCardNews();

  global.spiks = {
    initCardEvent,
  };
};

export default init;
